import { createReducer, createActions } from 'reduxsauce';
import { create } from 'apisauce';
import applicationLoadingActions from './applicationLoading';

let baseURL = 'https://owlichat.superlogica.com/'; 

if(window.__DEV__) {
    baseURL = 'http://localhost:8000/';
}

const api = create({baseURL});
//const api = create({baseURL : baseUrlDevelopment});

const { Types, Creators } = createActions({
    doLogin : (token)=>{
        return dispatch=>{
            dispatch(applicationLoadingActions.loadApplication());
            api.post('/auth',{token},{headers:{'Content-type':'application/json' }})
                .then((resp)=>{
                    if(resp.ok){
                        return dispatch({
                            type : Types.LOGIN_SUCCESS,
                            user : resp.data
                        });
                    }
                    return dispatch({
                        type: Types.LOGIN_NOT_AUTHORIZED
                    })
                });
        }
    },
    loginSuccess : ['payload'],
    loginNotAuthorized: null,
  }, {})

export const loginTypes = Types;
export default Creators;



/** -------Reducers------------- */
const loginSuccess = (state, action)=>({...state, user : action.user, authorized: true});
const loginNotAuthorized = (state, action)=>({...state, authorized : false});

/** -------Selectors------------- */
export const getUser = ({login})=>{
    return login.user;
}

export const reducer = createReducer({user : 'undefined'},{
    [Types.LOGIN_SUCCESS] : loginSuccess,
    [Types.LOGIN_NOT_AUTHORIZED] : loginNotAuthorized
})



// WEBPACK FOOTER //
// ./src/redux/loginStore.js